import { Shield } from 'lucide-react'

interface PremiumTrialTimelineProps {
  trialDays: number
  renewalPriceLabel: string
  className?: string
}

/**
 * Horizontal trial progress track shown on Premium plan cards.
 * A 4px rail with a brand gradient fill and two nodes (Today / first charge),
 * with labels underneath. Mirrors the redesigned pricing page's trial timeline.
 */
export function PremiumTrialTimeline({
  trialDays,
  renewalPriceLabel,
  className = '',
}: PremiumTrialTimelineProps) {
  return (
    <div
      className={`rounded-lg border border-green-100 bg-green-50 px-4 pb-3 pt-3.5 dark:border-green-900/50 dark:bg-green-900/15 ${className}`}
    >
      <div className="flex items-center gap-1.5 text-xs font-bold text-green-800 dark:text-green-300">
        <Shield className="h-3.5 w-3.5 shrink-0 text-green-600 dark:text-green-400" aria-hidden="true" />
        {trialDays} days free, no charge today
      </div>

      {/* Progress rail */}
      <div className="relative mx-1.5 mt-6 h-1 rounded-full bg-green-200 dark:bg-green-900/60">
        <div className="absolute inset-y-0 left-0 w-full rounded-full bg-linear-to-r from-green-600 to-emerald-600" />
        <span
          aria-hidden="true"
          className="absolute left-0 top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-green-600 bg-white dark:bg-gray-900"
        />
        <span
          aria-hidden="true"
          className="absolute left-full top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-gray-400 bg-white dark:bg-gray-900"
        />
      </div>

      <div className="mt-2.5 flex justify-between text-[10.5px] leading-tight text-gray-600 dark:text-gray-400">
        <div>
          <span className="block text-[11px] font-bold text-gray-900 dark:text-white">Today</span>
          Full access starts
        </div>
        <div className="text-right">
          <span className="block text-[11px] font-bold text-gray-900 dark:text-white">Day {trialDays}</span>
          {renewalPriceLabel} begins
        </div>
      </div>
    </div>
  )
}
